import React, { useEffect, useState, useCallback } from 'react';
import { getListeProduit, getTypeProduit } from '../../actions';
import { connect } from 'react-redux';
import { Autocomplete } from '@material-ui/lab';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import MaterialTable from 'material-table';
import { apiATC, imagesRepo, localization } from '../../config';
import Axios from 'axios';
import Image from 'react-bootstrap/Image';

const CentreVide = ({
    getListeProduit,
    listeRef = [],
    listeTypeProd = [],
    getTypeProduit,
}) => {
    // Chargement des données
    useEffect(() => {
        getListeProduit();
        getTypeProduit();
    }, [getListeProduit, getTypeProduit]);

    // Etats
    const [form, setForm] = useState({
        id: '',
        ref: '',
        type: null,
        facon: '',
        fsf: '',
        poids: '',
        serti: '',
        prenomLigne: '',
        mettreSurWordpress: false,
    });
    const [errorRef, setErrorRef] = useState('');
    const [okToAdd, setOkToAdd] = useState(true);

    // Vérification de la référence
    const onChangeRef = useCallback(
        (ref) => {
            const exist = Object.values(listeRef).find((r) => r.ref === ref);
            setErrorRef(exist ? 'Réf déja Existante' : '');
            setOkToAdd(!exist);
            setForm((prev) => ({ ...prev, ref }));
        },
        [listeRef]
    );

    // Préparation des données pour MaterialTable
    const returnList = useCallback(() => Object.values(listeRef), [listeRef]);

    // Sélection d'une ligne
    const handleClick = (event, rowData) => {
        event.preventDefault();
        onChangeRef(rowData.ref);
        setForm({
            id: rowData.id_cv,
            ref: rowData.ref,
            facon: rowData.facon,
            fsf: rowData.facon_fonte,
            poids: rowData.poids_metal,
            serti: rowData.serti_min,
            prenomLigne: rowData.prenom_ligne,
            mettreSurWordpress: rowData.wordpress === 1,
            type: listeTypeProd.find((r) => r.id_typ_prod === rowData.type_prod) || null,
        });
    };

    // Sauvegarde
    const handleSave = async () => {
        const { id, facon, fsf, poids, serti, type, prenomLigne, mettreSurWordpress } = form;
        const data = {
            table: 'centre_vide',
            primaryKey: 'id_cv',
            id,
            facon,
            facon_fonte: fsf,
            poids_metal: poids,
            serti_min: serti,
            type_prod: type?.id_typ_prod,
            prenom_ligne: prenomLigne,
            wordpress: mettreSurWordpress ? 1 : 0,
        };
        try {
            await Axios.post(`${apiATC}/general.php?action=modifier`, data);
            getListeProduit();
        } catch (error) {
            console.log(error);
        }
    };

    // Création
    const handleCreate = async () => {
        const { ref, facon, fsf, poids, serti, type, prenomLigne, mettreSurWordpress } = form;
        const data = {
            table: 'centre_vide',
            ref,
            facon,
            facon_fonte: fsf,
            poids_metal: poids,
            type_prod: type?.id_typ_prod,
            serti_min: serti,
            prenom_ligne: prenomLigne,
            wordpress: mettreSurWordpress ? 1 : 0,
        };
        try {
            await Axios.post(`${apiATC}/general.php?action=ajouter`, data);
            getListeProduit();
        } catch (error) {
            console.log(error);
        }
    };

    // Gestion des changements de champs
    const handleChange = (field) => (e) => {
        const value = field === 'mettreSurWordpress' ? e.target.checked : e.target.value;
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm">
                    <MaterialTable
                        style={{ fontSize: 12, zIndex: 0, padding: '0 !important' }}
                        columns={[
                            {
                                align: 'center',
                                title: 'Image',
                                field: 'image',
                                render: (rowData) => (
                                    <Image
                                        key={rowData.ref}
                                        src={`${imagesRepo}thumbs.php?src=${rowData.image}&size=100`}
                                        style={{ width: 100, height: 100 }}
                                        rounded
                                    />
                                ),
                            },
                            { title: 'Type', field: 'typeProd' },
                            { title: 'Ref', field: 'ref' },
                            { title: 'Facon', field: 'facon' },
                            { title: 'FSF', field: 'facon_fonte' },
                            { title: 'Poids', field: 'poids_metal' },
                            { title: 'Serti', field: 'serti_min' },
                            { title: 'Prenom', field: 'prenom_ligne' },
                        ]}
                        title={<div style={{ width: 170, fontSize: 16, display: 'flex' }}>Centre Vide</div>}
                        data={returnList()}
                        actions={[
                            {
                                tooltip: 'Rafraichir',
                                icon: 'refresh',
                                onClick: getListeProduit,
                                isFreeAction: true,
                            },
                        ]}
                        options={{
                            rowStyle: (rowData) => ({
                                backgroundColor: form.id === rowData.id_cv ? '#AED1FF' : '',
                            }),
                        }}
                        onRowClick={handleClick}
                        localization={localization}
                    />
                </div>
                <div className="col-sm">
                    <form>
                        <div className="form-group">
                            <TextField
                                label="Réf"
                                variant="outlined"
                                value={form.ref}
                                onChange={(e) => onChangeRef(e.target.value)}
                            />
                            <p>{errorRef}</p>
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Facon"
                                variant="outlined"
                                value={form.facon}
                                onChange={handleChange('facon')}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Facon sur Fonte"
                                variant="outlined"
                                value={form.fsf}
                                onChange={handleChange('fsf')}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Poids"
                                variant="outlined"
                                value={form.poids}
                                onChange={handleChange('poids')}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Serti"
                                variant="outlined"
                                value={form.serti}
                                onChange={handleChange('serti')}
                            />
                        </div>
                        <div className="form-group">
                            <TextField
                                label="Prénom Ligne"
                                variant="outlined"
                                value={form.prenomLigne}
                                onChange={handleChange('prenomLigne')}
                            />
                        </div>
                        <div className="form-group">
                            <Autocomplete
                                value={form.type}
                                options={listeTypeProd}
                                getOptionLabel={(option) => option.description}
                                onChange={(e, value) => setForm((prev) => ({ ...prev, type: value }))}
                                getOptionSelected={(option, value) => option.id_typ_prod === value?.id_typ_prod}
                                autoHighlight
                                autoComplete
                                clearOnEscape
                                style={{ width: 222 }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Type" variant="outlined" />
                                )}
                            />
                        </div>
                        <div className="form-group">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={form.mettreSurWordpress}
                                        onChange={handleChange('mettreSurWordpress')}
                                        color="primary"
                                    />
                                }
                                label="Afficher sur Wordpress"
                            />
                        </div>
                        <div className="form-group">
                            <button
                                type="button"
                                className="btn btn-link btn-sm"
                                onClick={handleCreate}
                                disabled={!okToAdd}
                            >
                                Ajouter
                            </button>
                            <button
                                type="button"
                                className="btn btn-link btn-sm"
                                onClick={handleSave}
                                disabled={okToAdd}
                            >
                                Enregistrer
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    listeRef: state.produit.listeReference,
    listeTypeProd: state.generalData.listeTypeProduit,
});
const mapDispatchToProps = {
    getListeProduit,
    getTypeProduit,
};
export default connect(mapStateToProps, mapDispatchToProps)(CentreVide);